import React, { useState } from 'react';
import "../DeckBuilder.css";
import cardsDictionary from "../../../constants/cardsDictionary.json";

import cardRemove from '../../../assets/images/card_remove.svg'
import { useDrop } from 'react-dnd'
function PowerDeckRow({ image, houseCard, alt, count, onDrop, handleRemove }) {
  const [{ canDrop, isOver }, drop] = useDrop(() => ({
    // The type (or types) to accept - strings or symbols
    accept: 'BOX',
    drop: onDrop,
    // Props to collect
    collect: (monitor) => ({
      isOver: monitor.isOver(),
      canDrop: monitor.canDrop()
    })
  }));

  const filteredCards = new Set([
    'plus_1', 'plus_2', 'plus_3', 'plus_4', 'plus_5', 'plus_6',
    'neg_1', 'neg_2', 'neg_3', 'neg_4', 'neg_5', 'neg_6',
    'plus_neg_1', 'plus_neg_2', 'plus_neg_3', 'plus_neg_4', 'plus_neg_5', 'plus_neg_6'
  ]);

  const isHouseCard = filteredCards.has(image);

  let powerCardName = "";
  if (image) {
    if (isHouseCard) {
      powerCardName = cardsDictionary.housePowerCards[image].name;
    }
    else {
      powerCardName = cardsDictionary.nftPowerCards[image].name;
    }
  }

  return (
    <div ref={drop} className={"deck-display-container" + (alt ? " deck-display-row" : "")}>
      {image !== "" && isHouseCard &&
        <img className="deck-display-card" src={`/bonez/images/cards/power-cards/${image.toString()}.svg`} alt="" />
      }
      {image !== "" && !isHouseCard &&
        <img className="deck-display-card" src={`/bonez/images/cards/power-cards/${image.toString()}.svg`} alt="" />
      }
      <h1 className="deck-display-text">{powerCardName}</h1>

      <h1 className="deck-display-text" style={{ marginLeft: "auto" }}>{count !== 0 && `x${count}`}</h1>

      <img
        className="card-remove"
        src={cardRemove}
        alt=""
        style={{ opacity: image === "" ? "0" : "1" }}
        onClick={() => {
          if (image !== "") {
            handleRemove(image)
          }
        }}
        draggable={false}
      />


    </div>
  )
}

export default PowerDeckRow